export const toastMessages = {
  notifiedNewMember:
    'Team member added and notified to join and create a profile',
  updatedMemeberRole: name =>
    `Team member role(s) for ${name} updated successfully`,
};
